(function () {
  // --- LP A/B variant stamping ---------------------------------------------
  // When a visitor arrives via the /pages/fa splitter (?lp=c|e), stamp the
  // bucket onto the cart as `lp_variant` so the winning landing page can be
  // read from orders in Shopify (the source of truth, not Meta). Only stamps
  // splitter-routed sessions; idempotent per browser session.
  (function stampLpVariant() {
    try {
      var lp = new URLSearchParams(window.location.search).get('lp');
      if (lp !== 'c' && lp !== 'e') return;
      if (sessionStorage.getItem('fa_lp_stamped') === lp) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { lp_variant: lp } })
      }).then(function () {
        try { sessionStorage.setItem('fa_lp_stamped', lp); } catch (e) {}
      }).catch(function () {});
    } catch (e) {}
  })();

  // Typewriter hero
  var el = document.querySelector('[data-fiction-typewriter]');
  if (el) {
    var lines = [];
    try { lines = JSON.parse(el.getAttribute('data-fiction-typewriter')) || []; } catch (e) { lines = []; }
    var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (lines.length && prefersReduce) {
      el.textContent = lines[0];  // static, no typing animation
    } else if (lines.length) {
      var i = 0, charIdx = 0, typing = true;
      function tick() {
        var line = lines[i];
        if (typing) {
          charIdx++;
          el.textContent = line.slice(0, charIdx);
          if (charIdx >= line.length) {
            typing = false;
            var pause = (line.indexOf('made up') > -1) ? 2400 : 1200;
            setTimeout(tick, pause);
            return;
          }
          setTimeout(tick, 55 + Math.random() * 35);
        } else {
          charIdx -= 2;
          if (charIdx < 0) charIdx = 0;
          el.textContent = line.slice(0, charIdx);
          if (charIdx <= 0) {
            typing = true;
            i = (i + 1) % lines.length;
            setTimeout(tick, 220);
            return;
          }
          setTimeout(tick, 22);
        }
      }
      setTimeout(tick, 500);
    }
  }

  // Toast
  function toast(msg) {
    var t = document.querySelector('.fiction-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'fiction-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  // Bump the cart count counters in the header without an extra fetch
  function bumpCartCount(by) {
    document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, [data-cart-item-count]').forEach(function (n) {
      var current = parseInt(n.textContent, 10);
      if (isNaN(current)) current = 0;
      n.textContent = current + by;
    });
    // Try several events common to Shopify themes; one should wake the drawer/count
    ['cart:refresh', 'cart:updated', 'cart:added', 'cart-drawer:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  // Quick-add buttons — optimistic UI: confirm instantly, fetch in background
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fiction-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (btn.dataset.busy === '1') return;  // prevent double-fires
    btn.dataset.busy = '1';

    var orig = btn.textContent;
    btn.textContent = 'Added ✓';
    btn.classList.add('is-added');
    toast('Added to cart');
    bumpCartCount(1);

    var resetAt = setTimeout(function () {
      btn.textContent = orig;
      btn.classList.remove('is-added');
      delete btn.dataset.busy;
    }, 900);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .catch(function () {
        // Roll back optimistic UI on failure
        clearTimeout(resetAt);
        bumpCartCount(-1);
        btn.textContent = 'Try again';
        btn.classList.remove('is-added');
        toast('Something went wrong — try again');
        setTimeout(function () {
          btn.textContent = orig;
          delete btn.dataset.busy;
        }, 1400);
      });
  });
})();
